// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import FolderOpenOutlinedSvg from "@ant-design/icons-svg/lib/asn/FolderOpenOutlined";
import AntdIcon from "../components/AntdIcon";
const FolderOpenOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: FolderOpenOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    FolderOpenOutlined.displayName = "FolderOpenOutlined";
}
export default /*#__PURE__*/ React.forwardRef(FolderOpenOutlined);
